import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from '@angular/core';

import { FilterConfig, FsFilterModule, ItemType } from '@firestitch/filter';
import { FsSidenavModule, MENU_DATA, SidenavMenuRef } from '@firestitch/sidenav';

import { Subject } from 'rxjs';

import { SidenavService } from '@libs/layouts/side-nav/services';


import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { SessionService } from '@app/core';
import { OrganizationData } from '@common/data';
import { Organization } from '@common/interfaces';
import { FsBadgeModule } from '@firestitch/badge';


// TU-T8973: InnoDB FULLTEXT ignores tokens shorter than innodb_ft_min_token_size
// (default 3), so a shorter keyword can never match -- gate the search on it.
const KEYWORD_MIN_LENGTH = 3;


@Component({
    templateUrl: './search-organization.component.html',
    styleUrls: ['./search-organization.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
    FsSidenavModule,
    FsFilterModule,
    FsBadgeModule,
    RouterLink,
    MatButton
],
})
export class SearchOrganizationComponent implements OnInit, OnDestroy {
  menuRef = inject<SidenavMenuRef<SearchOrganizationComponent>>(SidenavMenuRef);
  private _sessionService = inject(SessionService);
  private _organizationData = inject(OrganizationData);
  private _sidenavService = inject(SidenavService);
  private _cdRef = inject(ChangeDetectorRef);
  data = inject(MENU_DATA);


  public organizations: Organization[] = [];
  public config: FilterConfig;

  private _destroy$ = new Subject();

  public ngOnInit(): void {
    this.config = {
      queryParam: false,
      persist: false,
      autofocus: true,
      items: [
        {
          name: 'keyword',
          type: ItemType.Keyword,
          label: 'Search',
        },
      ],
      change: (query) => {
        this._load(query);
      },
      init: (query) => {
        this._load(query);
      },
    };
  }

  public close(): void {
    this.menuRef.close();
    this._sidenavService.hide();
  }

  public create(): void {
    this.close();
  }

  public ngOnDestroy(): void {
    this._destroy$.next(null);
    this._destroy$.complete();
  }

  private _load(query: any): void {
    query.environmentId = this._sessionService.environmentId();

    // TU-T8973: don't hit the FULLTEXT search until the keyword reaches the
    // minimum token length -- shorter keywords match nothing and only add load.
    const keyword = (query.keyword ?? '').trim();
    if (keyword && keyword.length < KEYWORD_MIN_LENGTH) {
      this.organizations = [];
      this._cdRef.markForCheck();

      return;
    }

    // TU-T8973: rank keyword matches by relevance, most relevant first.
    if (query.keyword && !query.order) {
      query.order = 'relevance';
    }

    this._organizationData.gets(query)
      .subscribe((response) => {
        this.organizations = response;
        this._cdRef.markForCheck();
      });
  }

}
